/* This file is autogenerated, see readme.md for instructions */
import ExperimentSvgIcon from '@bloomreach/banana-theme/icons/experiment.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ExperimentIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ExperimentSvgIcon />
    </Icon>
  );
});

ExperimentIcon.displayName = 'ExperimentIcon';

export default ExperimentIcon;
